import {
  faCloud,
  faComments,
  faFileInvoice,
  faFlag,
  faGears,
  faLightbulb,
  faPeopleGroup,
  faPuzzlePiece,
} from "@fortawesome/free-solid-svg-icons";

export const requerimentsJace = [
  {
    title: "Paso 1",
    icon: faFileInvoice,
    descriptions: [
      "Deberá encontrarse en situación militar de actividad con no más de 25 años de servicio como Oficial y 28 años como Técnico, o Sub Oficial.",
    ],
  },
  {
    title: "Paso 2",
    icon: faLightbulb,
    descriptions: [
      "Deberá ser casado y tener hijos con su cónyugue, mantener una relación estable y vivir con su cónyugue en la guarnición donde solicita la casa.",
    ],
  },
  {
    title: "Paso 3",
    icon: faComments,
    descriptions: [
      "Deberá tener como mínimo 4 años de servicio cumplido como Oficial o Sub Oficial, con el grado mínimo de Teniente o Sub Oficial 2°.",
    ],
  },
  {
    title: "Paso 4",
    icon: faCloud,
    descriptions: [
      "El personal militar que proviene de la reserva puede solicitar asignación de casa de servicio a partir de la fecha que pasen a la efectividad",
    ],
  },
  {
    title: "Paso 5",
    icon: faPeopleGroup,
    descriptions: [
      "El titular y/o su cónyuge no deben haber sido favorecidos con un préstamo del ORES – FOVIME.",
    ],
  },
  {
    title: "Paso 6",
    icon: faGears,
    descriptions: [
      "No debe haber ocupado casa de servicio en los 3 últimos años en la guarnición donde solicita.",
    ],
  },
  {
    title: "Paso 7",
    icon: faFlag,
    descriptions: [
      "El personal militar candidato a usuario no debe haber sido obligado a desocupar la casa de servicio en cualquiera de las guarniciones de Ejército donde existan casas de servicio.",
    ],
  },
  {
    title: "Paso 8",
    icon: faPuzzlePiece,
    descriptions: [
      "El personal militar candidato a “usuario” que solicite asignación especial o excepcional deberá contar con",
      "- Los documentos que acrediten la situación de especialidad o excepcionalidad.",
      "- El dictamen Legal favorable.",
      "- La opinión del Jefe de Administración de Casas del Ejército.",
      "- La aprobación del General de Brigada Comandante General del COBIENE para la guarnición de Lima.",
    ],
  },
];
